import { Accessor, Setter, type Component } from 'solid-js';
import { useTranslationState } from '@i18n/TranslationProvider';
import SectionHeader from '@molecules/SectionHeader';
import CreateOrJoinSessionBox from '@molecules/CreateOrJoinSessionBox';
import Text from '@atoms/Text';
import Header3 from '@atoms/Header3';
import BulletPoint from '@atoms/BulletPoint';

export interface HomeSectionProps {
    userName: Accessor<string>;
    setUserName: Setter<string>;
    onCreateSession: () => void | unknown;
    onJoinExistingRoom: () => void | unknown;
    onLoginOrRegister: (event: MouseEvent) => void | unknown;
}

const HomeSection: Component<HomeSectionProps> = (props) => {
    const t = useTranslationState().t;
    return (
        <>
            <SectionHeader title={t('homepage.header')} />
            <div class="h-6" />
            <Text fontSize="xsmall">{t('homepage.subtitle')}</Text>
            <div class="h-6" />
            <CreateOrJoinSessionBox
                userName={props.userName}
                setUserName={props.setUserName}
                onCreateSession={props.onCreateSession}
            />
            <div class="h-12" />
            <Header3>{t('homepage.benefits.title')}</Header3>
            <div class="h-2" />
            <BulletPoint>{t('homepage.benefits.line1')}</BulletPoint>
            <BulletPoint>{t('homepage.benefits.line2')}</BulletPoint>
            <BulletPoint>{t('homepage.benefits.line3')}</BulletPoint>
            <div class="h-6" />
            <Header3>{t('homepage.howItWorks.title')}</Header3>
            <div class="h-2" />
            <Text fontSize="small" color="primary" fontWeight="bold">
                {t('homepage.howItWorks.step1.title')}
            </Text>
            <div class="h-1" />
            <Text fontSize="small">
                {t('homepage.howItWorks.step1.subtitle')}
            </Text>
            <div class="h-2" />
            <Text fontSize="small" color="primary" fontWeight="bold">
                {t('homepage.howItWorks.step2.title')}
            </Text>
            <div class="h-1" />
            <Text fontSize="small">
                {t('homepage.howItWorks.step2.subtitle')}
            </Text>
            <div class="h-2" />
            <Text fontSize="small" color="primary" fontWeight="bold">
                {t('homepage.howItWorks.step3.title')}
            </Text>
            <div class="h-1" />
            <Text fontSize="small">
                {t('homepage.howItWorks.step3.subtitle')}
            </Text>
        </>
    );
};

export default HomeSection;
